var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_7596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5263 0H3.47368C1.55522 0 0 1.55522 0 3.47368V40.5263C0 42.4448 1.55522 44 3.47368 44H40.5263C42.4448 44 44 42.4448 44 40.5263V3.47368C44 1.55522 42.4448 0 40.5263 0Z",
    fill: "#4875B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5791 33.5792V25.086C33.5791 20.9292 32.6846 17.7305 27.8272 17.7305C25.4912 17.7305 23.9251 19.0099 23.2854 20.2257H23.2188V18.1184H18.6133V33.5792H23.407V25.9226C23.407 23.8963 23.7891 21.9568 26.3017 21.9568C28.8143 21.9568 28.797 24.2726 28.797 26.0528V33.5792H33.5791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8032 18.1172H15.6027V33.578H10.8032V18.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 10.4219C12.6464 10.4196 12.1046 10.5819 11.6434 10.8881C11.1822 11.1942 10.8224 11.6306 10.6096 12.1416C10.3968 12.6527 10.3407 13.2155 10.4483 13.7585C10.556 14.3015 10.8226 14.8003 11.2142 15.1916C11.6059 15.5828 12.1049 15.8489 12.6481 15.956C13.1912 16.063 13.7539 16.0063 14.2648 15.793C14.7756 15.5797 15.2116 15.2194 15.5173 14.7579C15.823 14.2964 15.9847 13.7544 15.9818 13.2008C15.9818 12.8357 15.9098 12.4741 15.77 12.1367C15.6302 11.7994 15.4252 11.4929 15.1669 11.2348C14.9085 10.9767 14.6018 10.7721 14.2643 10.6326C13.9268 10.4931 13.5652 10.4215 13.2 10.4219Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_7596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.a5c4a7a02344c6ea452c34bce7f04401.svg";
export { ForwardRef as ReactComponent };